import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import { db } from '../../config';
import { MasterType } from '../../../../types/master';
import { masterStatus } from '../../../../constants/enum';

export const getMastersByCompanyId = async (companyId: string): Promise<MasterType[]> => {
  const mastersRef = collection(db, 'masters');
  const q = query(mastersRef, where('company_id', '==', companyId), orderBy('updated_at', 'desc'));
  const snapshot = await getDocs(q);

  // 論理削除済み（status=99）は除外。status 未設定は有効扱い（#2896）。
  // where で status を絞ると未設定ドキュメントが取得できないため、取得後に JS でフィルタする。
  return snapshot.docs
    .map(doc => ({
      master_id: doc.id,
      ...doc.data(),
    }))
    .filter(m => (m as MasterType).status !== masterStatus.deleted) as MasterType[];
};
